<div class="row mb-3">
  <div class="col-md-5 mt-2 d-flex align-items-center">
    @if(title){
      <button (click)="goBack()" class="btn-sm btn-back me-2" color="default" mat-mini-fab matTooltip="{{ 'go-back' | translate }}">
      <mat-icon>keyboard_backspace</mat-icon>
    </button>
    }
    

    <div>
      @if (!isBoldedTitle) {
        <span class="mb-1 pb-0 page-title "> {{title | translate}}</span>
      }
      @if (isBoldedTitle) {
        <span class="mb-1 bolded-title fs-4 pb-0"> {{title | translate}}</span>
      }

      @if (subTitle) {
        <br>
          <h6 class="mb-1 sub-title pb-0"> <i>{{subTitle | translate}}</i></h6>
        }
      </div>
    </div>

    <div class="col-md-7 text-end mb-1">
      <ng-container *ngTemplateOutlet="topMenu"></ng-container>
    </div>
  </div>











